<div class="chat-events mat-elevation-z4">
  <div *ngFor="let event of events" class="event-row" [class.ongoing]="isOngoing(event)" [hidden]="isEnded(event)">
    <span class="event-name">{{ event.name }}</span>
    <span class="event-date">
      <mat-icon matTooltip="Inicio">event</mat-icon>
      {{ event.start_date | date: 'short' }}
    </span>
    <span class="event-duration">
      <mat-icon matTooltip="Duración">schedule</mat-icon>
      {{ event.duration }}h
    </span>
    <span *ngIf="isOngoing(event)" class="event-time-elapsed">
      {{ timeElapsed(event) }}
      <mat-icon matTooltip="Tiempo transcurrido" class="ongoing-icon">play_circle</mat-icon>
    </span>
    <span *ngIf="!isOngoing(event)" class="event-time-remaining">
      {{ timeRemaining(event) }}
      <mat-icon matTooltip="Tiempo restante">hourglass_top</mat-icon>
    </span>
  </div>
</div>